var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"merchant-preload"},[_c('content-loader',{attrs:{"height":215,"width":160,"speed":2,"primaryColor":"#f3f3f3","secondaryColor":"#ecebeb"}},[_c('rect',{attrs:{"x":"0","y":"16","rx":"5","ry":"5","width":"160","height":"160"}}),_c('rect',{attrs:{"x":"20","y":"195","rx":"5","ry":"5","width":"120","height":"20"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }